<template>
    <b-form-checkbox-group
        :checked="effectiveValue"
        :options="options"
        stacked
        @input="$emit('input', $event)"
    />
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({ name: "CheckboxArrayField" })
export default class CheckboxArrayField extends Vue {
    @Prop({ default: () => [] }) value!: string[];
    @Prop({ type: Array, required: true }) options!: Array<{ text: string; value: string }>;

    /**
     * Opt-in for fields whose backend semantic is "null/empty = all allowed". When true,
     * a null or empty <c>value</c> renders every option as checked so the UI matches the
     * data model. The parent's value stays null until the user actually toggles something
     * — only then does an input event fire with an explicit list. Default false preserves
     * the existing semantic for fields where empty really means "nothing" (e.g.
     * <c>clinicallySignificantFields</c>).
     */
    @Prop({ type: Boolean, default: false }) defaultAllChecked!: boolean;

    get effectiveValue(): string[] {
        const hasValue = Array.isArray(this.value) && this.value.length > 0;
        if (hasValue) return this.value;
        if (this.defaultAllChecked) return this.options.map(o => o.value);
        return [];
    }
}
</script>
